import constant, { RESULT_STATUS } from "../../../../constants";
import CreatableSelect from "react-select/creatable";
import AlertContext from "../../../../context/AlertContext";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import ModulesHooks from "../../../../Hooks/Question/ModulesHooks";
import { LibraryContext } from "../../../../context/LibraryContext";
import React, { useState, useEffect, memo, useContext } from "react";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";

const customStylesForTopic = {
  control: (base, state) => ({
    ...base,
    marginTop: "20px",
    maxHeight: "40px !important",
    border: "1px solid #BDC1C6",
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      width: "370px",
      height: "36px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      background: "white",
      fontFamily: "Inter",
      color: isSelected ? "#000000" : undefined,
      ":hover": {
        color: "white",
        backgroundColor: "#0d6efd",
      },
    };
  },
  singleValue: (styles, { data }) => ({
    ...styles,
    color: "#202124",
    fontSize: "14px",
    fontWeight: "400",
    textAlign: "left",
    lineHeight: "20px",
    fontStyle: "normal",
    fontFamily: "Inter",
    paddingLeft: "10px",
    borderRadius: "20px",
  }),
  menuList: (base) => ({
    ...base,
    textAlign: "left",
    maxHeight: "150px",
    overflowX: "hidden",
    borderRadius: "2px",
  }),
};

const Modules = () => {
  const Alert = useContext(AlertContext);
  const LibraryCxt = useContext(LibraryContext);

  const axios = useAxiosPrivate();
  const ModulesHks = ModulesHooks();
  const useCommonFunctionHks = useCommonFunctionHooks();

  const [topicList, setTopicList] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState();
  const [runningMaxTopicID, setRunningMaxTopicID] = useState();
  const [fromEditQuestion, setFromEditQuestion] = useState(false);

  let currentMax = runningMaxTopicID;

  const createOption = (label) => ({
    label,
    value: getLength(),
  });

  const getLength = () => {
    if (currentMax > 0) {
      return currentMax + 1;
    }

    return runningMaxTopicID + 1;
  };

  const handleCreate = (inputValue) => {
    LibraryCxt.setIsSelectedTopic(false);
    currentMax = runningMaxTopicID;
    setMaxTopicId(currentMax + 1);

    if (
      inputValue.trim().length === 0 ||
      topicList.filter((option) => option.label === inputValue).length > 0
    ) {
    } else {
      const newOption = createOption(inputValue);

      setTopicList((prev) => [...prev, newOption]);
      setSelectedTopic(newOption);

      if (
        Alert.tableShowStatus === constant.libTypeIds.MCQ ||
        Alert.tableShowStatus === constant.libTypeIds.DESCRIPTIVE ||
        Alert.tableShowStatus === constant.libTypeIds.CODING_SNIPPET ||
        Alert.tableShowStatus === constant.libTypeIds.CODING_CHALLENGE ||
        Alert.tableShowStatus === constant.libTypeIds.SQL
      ) {
        LibraryCxt.setTopic({
          type: "name",
          name: newOption.label,
          value: null,
        });
      }

      ModulesHks.handleInputChange({
        name: "topicname",
        value: newOption.label,
      });
    }
  };

  const setMaxTopicId = (topics) => {
    let maxId = 0;

    for (let i = 0; i < topics.length; i++) {
      if (topics[i].value > maxId) {
        maxId = topics[i].value;
      }
    }

    setRunningMaxTopicID(maxId);
  };

  useEffect(() => {
    if (
      (Alert.tableShowStatus === constant.libTypeIds.MCQ ||
        Alert.tableShowStatus === constant.libTypeIds.SQL ||
        Alert.tableShowStatus === constant.libTypeIds.DESCRIPTIVE ||
        Alert.tableShowStatus === constant.libTypeIds.CODING_SNIPPET ||
        Alert.tableShowStatus === constant.libTypeIds.CODING_CHALLENGE) &&
      LibraryCxt.handleadd
    ) {
      setSelectedTopic(null);
      LibraryCxt.setTopic(null);
    }
  }, [LibraryCxt.handleadd, Alert.tableShowStatus]);

  const handleChange = (newValue) => {
    LibraryCxt.setIsSelectedTopic(false);

    if (
      Alert.tableShowStatus === constant.libTypeIds.MCQ ||
      Alert.tableShowStatus === constant.libTypeIds.SQL ||
      Alert.tableShowStatus === constant.libTypeIds.DESCRIPTIVE ||
      Alert.tableShowStatus === constant.libTypeIds.CODING_SNIPPET ||
      Alert.tableShowStatus === constant.libTypeIds.CODING_CHALLENGE
    ) {
      LibraryCxt.setTopic({
        type: "id",
        name: newValue?.label,
        value: newValue?.value,
      });
    }

    setSelectedTopic(newValue);

    if (newValue !== null && newValue.value > runningMaxTopicID) {
      ModulesHks.handleInputChange({
        name: "topicname",
        value: newValue?.label,
      });
    } else {
      ModulesHks.handleInputChange({ name: "topic", value: newValue?.value });
    }
  };

  if (
    Alert.isqueReport &&
    LibraryCxt.isSelectedTopic &&
    Alert.tableShowStatus !== constant.libTypeIds.MCQ &&
    Alert.tableShowStatus !== constant.libTypeIds.DESCRIPTIVE &&
    Alert.tableShowStatus !== constant.libTypeIds.CODING_SNIPPET &&
    Alert.tableShowStatus !== constant.libTypeIds.CODING_CHALLENGE
  ) {
    LibraryCxt.setAlreadySelected(null);
  }

  useEffect(() => {
    axios
      .get(
        `node/admin/topic/get/${0}`,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      )
      .then((res) => {
        if(res.data.resultCode === RESULT_STATUS.SUCCESS){
                  
          let json = res.data.data;
          let topics = json.map((top) => {
            return {
              value: top.id,
              label: top.name,
            };
          });

          setTopicList(topics);
          LibraryCxt.setTopics(topics);
          setSelectedTopic(topics.find((obj) => obj.value === null));
          setMaxTopicId(topics);
        }
      })
      .catch((error) => {
        useCommonFunctionHks.getCatchBlockDetails(error);
      });

    setFromEditQuestion(Alert.isqueReport);
  }, []);

  return (
    <div className="modulesMainContainer">
      <label htmlFor="selectModule">Topic</label>

      <CreatableSelect
        required
        isClearable
        name="topic"
        options={topicList}
        value={selectedTopic}
        onCreateOption={handleCreate}
        styles={customStylesForTopic}
        className="questionTopicSelect"
        components={{ IndicatorSeparator: () => null }}
        onChange={(newValue) => {
          handleChange(newValue);
        }}
      />
    </div>
  );
};

export default memo(Modules);
